module.exports = __webpack_public_path__ + "assets/ETH.fcd86c32.svg";